const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const sendSmsAllFields = [
    {
    id: "fromEmail",
    label: "Sender Email",
    placeHolder: "select",
    type: "select",
    options: [],
    md:6,
  },
  {
    id: "toMail",
    label: "Receiver Email",
    placeholder: "Enter Receiver Email",
    type: "email",
    md: 6,
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  
    {
    id: "cc",
    label: "CC",
    placeHolder: "Enter CC email",
    type: "chipText",
    isRequired: true,
    // firstColmd: 2.5,
    md: 6,
  },

  {
    id: "bcc",
    label: "BCC",
    placeHolder: "Enter BCC email",
    type: "chipText",
    isRequired: true,
     // firstColmd: 2.5,
    md: 6,
  },
  {
    id: "subject",
    label: "Subject",
    placeholder: "Enter subject",
    type: "richtext",
    editorConfig: {
      hideFontControls: true,
    },
    md: 12,
    isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "htmlBody",
    label: "HTML Body",
    placeHolder: "Enter body",
    type: "richtext",
    isRequired: true,
    md: 12,
    minRows: 4,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    // editReadOnly: true,
  },
  {
    id: "signature",
    label: "Signature",
    type: "richtext",
    // mdSize:4.5,
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "signature_option",
    checkLabel: "Add Signature",
    type: "checkbox",
    mdSize: 4.5,
    // isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const groupNames = [
  {
    id: 1,
    Label: "New Lead",
  },
  {
    id: 2,
    Label: "Surveyors",
  },
  {
    id: 3,
    Label: "Sales",
  },
  {
    id: 4,
    Label: "Customer Service",
  },
];
